import { CoachingExplanation }
  from "@/components/coaching/CoachingExplanation";
import { CoachingMetric, CoachingSectionCard }
  from "@/components/coaching/CoachingSectionCard";
import { SportBadge } from "@/components/SportBadge";
import {
  formatComplianceCategory,
  formatConfidence,
  formatDate,
  formatRpeAgreement,
} from "@/lib/coachingFormatters";

export const RecentSessionCard = ({ recent, timezone,
                                                    explanation, error }) => {
  const isEmpty = !error && !recent;
  return (
    <CoachingSectionCard
      title="Last session"
      headingId="coaching-recent-heading"
      testId="coaching-recent-card"
      error={error}
      empty={isEmpty ? "Not available yet." : null}
    >
      {!isEmpty && recent && (
        <>
          <div className="flex flex-wrap items-center gap-2 mb-4">
            {recent.sport && <SportBadge sport={recent.sport} />}
            <span className="meta-text">
              {formatDate(recent.session_date, timezone)}
            </span>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            <CoachingMetric label="Workout" value={recent.workout_name} testId="recent-workout" />
            <CoachingMetric label="Execution" value={formatComplianceCategory(recent.execution_status)} testId="recent-execution" />
            <CoachingMetric label="Compliance" value={formatComplianceCategory(recent.compliance_category)} testId="recent-compliance" />
            <CoachingMetric label="Duration" value={formatComplianceCategory(recent.duration_comparison)} testId="recent-duration" />
            <CoachingMetric label="Intensity" value={formatComplianceCategory(recent.intensity_status)} testId="recent-intensity" />
            <CoachingMetric label="RPE" value={formatRpeAgreement(recent.rpe_agreement)} testId="recent-rpe" />
          </div>
          {Array.isArray(recent.missing_dimensions)
              && recent.missing_dimensions.length > 0 && (
            <div className="mt-3 meta-text" data-testid="recent-missing">
              Missing sensors: {recent.missing_dimensions.join(", ")}
            </div>
          )}
          <div className="mt-2 card-label">
            {formatConfidence(recent.confidence)}
          </div>
          {explanation && (
            <div className="mt-4 pt-4 border-t border-[var(--border-primary)]">
              <CoachingExplanation
                explanation={explanation}
                testId="recent-explanation"
              />
            </div>
          )}
        </>
      )}
    </CoachingSectionCard>
  );
};
